import AuthGroup from '@/logic/auth/AuthGroup';

// Array of groups that require MFA to unlock all functionality
const MFAGroups = [AuthGroup.Direct, AuthGroup.Admin, AuthGroup.EndUsers];

export default MFAGroups;
